import { Card, Spinner } from "@adfenix/alexandria";
import { SolidXmark } from "@adfenix/icons";
import styled from "styled-components";

interface Props {
  src: string | undefined;
  loading: boolean;
}

const StyledImage = styled.img`
  max-width: 200px;
  max-height: 200px;
`;

export const Image = ({ src, loading }: Props) => {
  if (loading) {
    return (
      <Card p="xs" display="flex" flexDirection="column" alignItems="center">
        <Spinner />
      </Card>
    );
  }

  return !!src ? (
    <StyledImage src={src} alt="agent-image" />
  ) : (
    <Card p="xs" display="flex" flexDirection="column" alignItems="center">
      <SolidXmark width={100} height={100} />
    </Card>
  );
};
